/** Contrato com /api/v1/templates. */

export interface Template {
  id: string
  nome: string
  canal: 'email' | 'sms' | 'whatsapp'
  assunto: string | null
  preHeader: string | null
  fromNome: string | null
  fromEmail: string | null
  corpoHtml: string | null
  corpoTexto: string
  criadoEm: string
  atualizadoEm: string
}

export const NOME_CANAL: Record<Template['canal'], string> = {
  email: 'E-mail',
  sms: 'SMS',
  whatsapp: 'WhatsApp',
}
